module.exports = __webpack_public_path__ + "static/media/index-bg.070b6bb0.jpg";